import { defineAsyncComponent } from 'vue'

const ClientCommunicationMessageModal = defineAsyncComponent(() =>
  import('./client-communication-message-modal.vue'),
)
const ClientCommunicationMessagesTable = defineAsyncComponent(() =>
  import('./client-communication-messages-table.vue'),
)

const ClientCommunicationMessagesDeliverAt = defineAsyncComponent(() =>
  import('./client-communication-messages-deliver-at-time.vue'),
)

const ClientCommunicationMessagesSentAt = defineAsyncComponent(() =>
  import('./client-communication-messages-sent-at-time.vue'),
)

const KINDS = [
  { value: 'pristine', label: 'Original' },
  { value: 'update', label: 'Update' },
  { value: 'opt_out', label: 'Opt-out' },
  { value: 'custom', label: 'Custom' },
]

const STATES = [
  { value: 'draft', label: 'Draft' },
  { value: 'outbox', label: 'Outbox', iconClass: 'mi-outlined mi-all-inbox' },
  { value: 'sending', label: 'Sending now', iconClass: 'mi-outlined mi-outbox' },
  { value: 'sent', label: 'Sent', iconClass: 'mi-outlined mi-pending' },
  { value: 'not_sent', label: 'Error' },
  { value: 'discarded', label: 'Discarded' },
]

export {
  ClientCommunicationMessageModal,
  ClientCommunicationMessagesDeliverAt,
  ClientCommunicationMessagesSentAt,
  ClientCommunicationMessagesTable,
  KINDS,
  STATES,
}
